import{tag as t}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const Checkmark75Icon=()=>t`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    aria-hidden="true"
    fill="currentColor"
  >
    <path
      d="M3.667 9.07a.96.96 0 01-.737-.344L.753 6.114a.96.96 0 111.474-1.23l1.418 1.701 4.112-5.233a.96.96 0 011.51 1.186L4.422 8.704a.962.962 0 01-.741.367z"
    />
  </svg>`;
//# sourceMappingURL=Checkmark75.js.map
